/* eslint no-multi-str: 0 */
import React, { Component } from 'react'
import { Template } from './template';
import moment from 'moment'
import { msToReadingTime } from '../../utils'
import RouteResolver from '../../route-resolver'
import { RichText } from 'prismic-reactjs'
import LinkResolver from '../../link-resolver'
// import { Link } from 'found'
import ReactDOMServer from 'react-dom/server';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
// Images
// import arrowFwIcon from '../../images/ARROW-FW.svg'
import timeIcon from '../../images/time.svg'
import calendarIcon from '../../images/calendar.svg'
import greyTimeIcon from '../../images/grey_time.svg'
import instagramIcon from '../../images/instagram_1.svg'
import calendarGreyIcon from '../../images/calendar-icon_g.svg'
// import quotationTopIcon from "../../images/quotation-top.svg"
// import quotationBottomIcon from "../../images/quotation-bottom.svg"
import twitterIcon from '../../images/twitter.svg'
import facebookIcon from '../../images/facebook.svg'
import websiteIcon from '../../images/website.svg'

// import { createFragmentContainer } from 'react-relay'
import graphql from 'babel-plugin-relay/macro' 

Object.unfreeze = function (o) {
    var oo = undefined;
    if (o instanceof Array) {
        oo = []; var clone = function (v) { oo.push(v) };
        o.forEach(clone);
    } else if (o instanceof String) {
        oo = o.toString();
    } else if (typeof o === 'object') {

        oo = {};
        for (var property in o) { oo[property] = o[property]; }


    }
    return oo;
}

class AmpBuilderPage extends Component {
    // constructor() {
    //     super()

    //     // document.body.write('<script> window.prerenderReady = false; </script>')
    // }

    crawledArticles = {}
    componentDidMount() {
        // window.prerenderReady = false;


        // console.log("Stuff")
        // console.log(this.crawledArticles)
        this.crawledArticles.articles = Object.unfreeze(this.props.articles)

        var routeResolver = RouteResolver

        for (let i in this.crawledArticles.articles) {
            this.crawledArticles.articles[i] = {
                publishedAt: moment(this.crawledArticles.articles[i].publishedAt),
                slug: this.crawledArticles.articles[i].slug,
                title: this.crawledArticles.articles[i].title,
                caption: this.crawledArticles.articles[i].caption,
                readingTime: msToReadingTime(this.crawledArticles.articles[i].readingTime),
                picture: this.crawledArticles.articles[i].picture,
                widePicture: this.crawledArticles.articles[i].widePicture,
                videoLink: this.crawledArticles.articles[i].videoLink,
                author: this.crawledArticles.articles[i].author,
                sponsor: this.crawledArticles.articles[i].sponsor,
                group: this.crawledArticles.articles[i].city ? {
                    link: routeResolver.location.get(this.crawledArticles.articles[i].city.slug),
                    latestArticles: this.crawledArticles.articles[i].city.articles
                        .filter(a => a.slug !== this.crawledArticles.articles[i].slug)
                        .map(a => ({
                            ...a,
                            link: routeResolver.article.get(this.crawledArticles.articles[i].city.slug, a.slug),
                        })),
                    ...this.crawledArticles.articles[i].city,
                } : {
                    link: routeResolver.category.get(this.crawledArticles.articles[i].category.slug),
                    latestArticles: this.crawledArticles.articles[i].category.articles
                        .filter(a => a.slug !== this.crawledArticles.articles[i].slug)
                        .map(a => ({
                            ...a,
                            link: routeResolver.article.get(this.crawledArticles.articles[i].category.slug, a.slug),
                        })),
                    ...this.crawledArticles.articles[i].category,
                },
                slices: this.crawledArticles.articles[i].slices,
                seo: this.crawledArticles.articles[i].seo,
                generic: this.crawledArticles.articles[i].social.generic[0],
                twitter: this.crawledArticles.articles[i].social.twitter[0],
            }
        }

        this.downloadFile()
    }

    zipFile() {
        var zip = new JSZip();

        for (let i in this.crawledArticles.articles) {
            for (var j in this.imageMap) {
                // console.log(this.imageMap[i]);
                this.template[i] = this.template[i].replace('width="' + this.imageMap[j].url + '"', 'width="' + this.imageMap[j].width + '"')
                this.template[i] = this.template[i].replace('height="' + this.imageMap[j].url + '"', 'height="' + this.imageMap[j].height + '"')
            }
            this.template[i] = this.template[i].replace(`target=""`, `target="_blank"`)
            this.template[i] = this.template[i].replace(`target=""`, `target="_blank"`)
            zip.file(this.crawledArticles.articles[i].slug + '.html', this.template[i]);
        }
        // var img = zip.folder("images");
        // img.file("smile.gif", imgData, {base64: true});
        zip.generateAsync({ type: "blob" })
            .then((content) => {
                // see FileSaver.js
                // new FileSaver(content, "example.zip")
                saveAs(content, "all_amp.zip");
            });
    }

    pageButtons = [<button style={{ margin: `40px` }} onClick={() => this.zipFile()}>Download .zip</button>]
    render() {
        return <div key="12" className="buttonList">
            {this.pageButtons}
        </div>
    }

    download(filename, text) {
        for (var i in this.imageMap) {
            // console.log(this.imageMap[i]);
            text = text.replace('width="' + this.imageMap[i].url + '"', 'width="' + this.imageMap[i].width + '"')
            text = text.replace('height="' + this.imageMap[i].url + '"', 'height="' + this.imageMap[i].height + '"')
        }

        text = text.replace(`target=""`, `target="_blank"`)
        text = text.replace(`target=""`, `target="_blank"`)
        text = text.replace(/href="\//g, `href="https://startupguide.com/`)

        var element = document.createElement('a');
        element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
        element.setAttribute('download', filename + ".html");
        element.setAttribute('id', "download-button");
        element.innerHTML = "Baixar página"
        element.style.display = 'none';
        document.querySelector('body').appendChild(element);

        element.click();

        document.body.removeChild(element);
    }

    template = [];

    downloadFile() {

        for (let j in this.crawledArticles.articles) {
            this.template[j] = "" + Template;
            //Create metatags
            var metatags = '\
        <title>' + (this.crawledArticles.articles[j].seo.title ? this.crawledArticles.articles[j].seo.title : "Startup Guide - " + this.crawledArticles.articles[j].title) + '</title>\
        <meta content="' + (this.crawledArticles.articles[j].seo.description ? this.crawledArticles.articles[j].seo.description : this.crawledArticles.articles[j].caption) + '" name="description" />\
\
        <meta property="article:author" content="' + (this.crawledArticles.articles[j].author.firstname + ' ' + this.crawledArticles.articles[j].author.lastname) + '" />\
        <meta property="article:published_time" content="' + this.crawledArticles.articles[j].publishedAt.format('YYYY-MM-DD') + '" />\
        <meta property="og:type" content="article" />\
        <meta property="og:title" content="' + (this.crawledArticles.articles[j].generic && this.crawledArticles.articles[j].generic.title ? this.crawledArticles.articles[j].generic.title : this.crawledArticles.articles[j].title) + '" />\
        <meta property="og:description" content="' + (this.crawledArticles.articles[j].generic && this.crawledArticles.articles[j].generic.description ? this.crawledArticles.articles[j].generic.description : this.crawledArticles.articles[j].caption) + '" />\
        <meta property="og:image" content="' + (this.crawledArticles.articles[j].generic && this.crawledArticles.articles[j].generic.image ? this.crawledArticles.articles[j].generic.image : this.crawledArticles.articles[j].picture) + '" />\
        <meta property="og:url" content="https://startupguide.com/' + this.crawledArticles.articles[j].slug + '"></meta>\
        <meta property="og:site_name" content="StartupGuide"></meta>\
\
        <meta name="twitter:card" content="' + (this.crawledArticles.articles[j].twitter && this.crawledArticles.articles[j].twitter.type.includes('Standard') ? 'summary' : 'summary_large_image') + '"></meta>\
        <meta name="twitter:site" content="@StartupGuideHQ"></meta>\
        <meta name="twitter:creator" content="' + (this.crawledArticles.articles[j].twitter && this.crawledArticles.articles[j].twitter.handle ? this.crawledArticles.articles[j].twitter.handle : '@StartupGuideHQ') + '"></meta>\
        <meta name="twitter:title" content={this.crawledArticles.articles[j].twitter&&this.crawledArticles.articles[j].twitter.title?this.crawledArticles.articles[j].twitter.title:this.crawledArticles.articles[j].title}></meta>\
        <meta name="twitter:description" content={this.crawledArticles.articles[j].twitter&&this.crawledArticles.articles[j].twitter.description?this.crawledArticles.articles[j].twitter.description:this.crawledArticles.articles[j].caption}></meta>\
        <meta name="twitter:image" content={this.crawledArticles.articles[j].twitter&&this.crawledArticles.articles[j].twitter.image?this.crawledArticles.articles[j].twitter.image:this.crawledArticles.articles[j].picture}></meta>\
        <link rel="canonical" href="https://startupguide.com/'+ this.crawledArticles.articles[j].slug + '">\
        '
            this.template[j] = this.template[j].replace('[[DYNAMIC_METATAGS]]', metatags)

            var imageHeader = ''
            if (this.crawledArticles.articles[j].videoLink) {
                imageHeader = '\
                    <div>\
                        <div class="hero-video">\
                            <div class="video">\
                                <div\
                                    style="padding-top: \'56.17021276595745%\'"\
                                    id="w-node-8234d4ae9a0e"\
                                    class="w-video w-embed"\
                                >' +
                    this.crawledArticles.articles[j].videoLink
                    + '</div>\
                            </div>\
                        </div>\
                        <div class="header-title---video">\
                            <div class="container-10 w-container" style="margin-top:126px;">\
                                <h1 class="title-video" style="font-size: 36px;line-height: 38px;text-align: center;">'+ this.crawledArticles.articles[j].title + '</h1>\
                                <div class="article-content-details-video w-clearfix" style="color: #ccc;display: flex;flex-direction: column;align-items: center;">\
                                    <h5 class="article-author-video">'+ this.crawledArticles.articles[j].author.firstname + ' ' + this.crawledArticles.articles[j].author.lastname + '</h5>\
                                    <amp-img src="'+ calendarGreyIcon + '" width="15" height="15" alt="" class="image-45"></amp-img>\
                                    <h5 class="article-reading-time video" style="color: #ccc;">' + this.crawledArticles.articles[j].publishedAt.format('YYYY-MMM-DD') + '</h5>\
                                </div>\
                            </div>\
                        </div>\
                    </div>\
                '
            } else {
                imageHeader = '\
              <div class="hero-image" style="background-size: cover; background:-webkit-linear-gradient(81deg, rgba(0, 0, 0, .38) 11%, transparent 70%), url(' + this.crawledArticles.articles[j].picture + ') no-repeat center;    background-size: 300%;">\
                 <div class="article_header">\
                    <h1 class="page-title-post">' + this.crawledArticles.articles[j].title + '</h1>\
                    <div class="article-content-details w-clearfix">\
                       <h5 class="article-author">'+ this.crawledArticles.articles[j].author.firstname + ' ' + this.crawledArticles.articles[j].author.lastname + '</h5>\
                       <amp-img alt="" src="'+ timeIcon + '"  height="15" width="15" class="image-44"></amp-img>\
                       <h5 class="article-reading-time">'+ this.crawledArticles.articles[j].readingTime + '</h5>\
                       <amp-img alt="" src="'+ calendarIcon + '"  height="15" width="15" class="image-45"></amp-img>\
                       <h5 class="article-reading-time">'+ this.crawledArticles.articles[j].publishedAt.format('DD MMM YYYY') + '</h5>\
                    </div>\
                 </div>\
              </div>\
            ';

                // imageHeader =
                //         <div  key="3" class="hero-image">
                //             <div class="article_header">
                //                 <h1 class="page-title-post margin-bottom-16px-copy">{this.crawledArticles.articles[j].title}</h1>
                //                 <div class="article-content-details margin-bottom-24px w-clearfix">
                //                     <h5 class="article-author-copy">{this.crawledArticles.articles[j].author.firstname} {this.crawledArticles.articles[j].author.lastname}</h5>
                //                     <img alt="" src={timeIcon} width={15} height={15} class="image-44" />
                //                     <h5 class="article-reading-time">{this.crawledArticles.articles[j].readingTime}</h5>
                //                     <img alt="" src={calendarIcon} width={15} height={15} class="image-45" />
                //                     <h5 class="article-reading-time">{this.crawledArticles.articles[j].publishedAt.format('DD MMM YYYY')}</h5>
                //                 </div>
                //                 <ol class="breadcrumb w-hidden-tiny w-list-unstyled">
                //                     <li class="breadcrumb-item" />
                //                     <li class="breadcrumb-item">
                //                         <a class="link-10">...</a>
                //                     </li>
                //                     <li class="breadcrumb-item">
                //                         <img alt="" src={arrowFwIcon} width={16} height={16} class="breadcrumb-divider" />
                //                         <Link to={this.crawledArticles.articles[j].group.link} class="link-8">{this.crawledArticles.articles[j].group.name}</Link>
                //                     </li>
                //                     <li class="breadcrumb-item"><img alt="" src={arrowFwIcon} width={16} height={16} class="breadcrumb-divider" />
                //                         <div class="active"></div>
                //                     </li>
                //                 </ol>
                //             </div>
                //             <div
                //                 class="div-block-48"
                //                 style={{
                //                     background: '-webkit-linear-gradient(81deg, rgba(0, 0, 0, .38) 11%, transparent 70%), url(' + this.crawledArticles.articles[j].picture + ') no-repeat center',
                //                     backgroundSize: 'cover',
                //                 }}
                //             />
                //         </div>
            }

            this.template[j] = this.template[j].replace("[[DYNAMIC-HEADER]]", imageHeader)
            let listKey = 0;

            // TODO: I suspect this should be a foreach instead of a map but right now I'm just ignoring it
            // eslint-disable-next-line array-callback-return
            this.crawledArticles.articles[j].slices.map((s, sk, slices) => {
                if (s.type === 'intro') {
                    this.template[j] = this.template[j].replace("[[DYNAMIC-ARTICLE-CONTENT]]", `<amp-img alt="" src="` + s.intro.initialLetter + `" width="34"  height="43.7" class="first-letter"></amp-img>
                    <p class="paragraph-intro">`+ s.intro.text + `
                    </p>[[DYNAMIC-ARTICLE-CONTENT]]`)
                }
                if (s.type === 'inline_picture') {
                    this.getRealImgSize(s.inlinePicture.picture)
                    this.template[j] = this.template[j].replace("[[DYNAMIC-ARTICLE-CONTENT]]", `<div class="article-content-image-and-caption">
                     <amp-img alt="" layout="intrinsic" width="` + s.inlinePicture.picture + `" height="` + s.inlinePicture.picture + `" src="` + s.inlinePicture.picture + `"></amp-img>
                     <p class="image-caption">` + s.inlinePicture.caption + `</p>
                  </div>[[DYNAMIC-ARTICLE-CONTENT]]`)
                }
                if (s.type === 'text___picture') {
                    this.getRealImgSize(s.inlinePicture.picture)
                    this.template[j] = this.template[j].replace("[[DYNAMIC-ARTICLE-CONTENT]]", `
                      <div class="text-pic article-container w-clearfix `+ ((s.textPicture.content[0].label === 'Left Align') ? 'text-left' : 'text-right') + `">
                         <div class='tp-container tp-img'>
                             <amp-img layout="intrinsic" alt="" width="` + s.inlinePicture.picture + `" height="` + s.inlinePicture.picture + `" src="` + s.textPicture.picture + `"></amp-img>
                         </div>
                         <div class="tp-container">
                  [[DYNAMIC-ARTICLE-CONTENT]]`)

                    this.template[j] = this.template[j].replace("[[DYNAMIC-ARTICLE-CONTENT]]", s.textPicture.content.map((p, k) => {
                        // console.log(p.type)
                        return ``
                            +
                            ((p.type.indexOf('heading') !== -1) ?
                                `<h` + p.type.replace('heading', '') + ` class="article-secondary-headline margin-top-0px">`
                                + RichText.asText([p], LinkResolver) +
                                `</h` + p.type.replace('heading', '') + `>`
                                : '')
                            + ((p.type === 'o-list-item') ?
                                `<div class="paragraph-normal-2 clearfix">` +
                                RichText.asText([p], LinkResolver, (type, element, content, children, key) => {
                                    let props = {}
                                    if (type === RichText.Elements.oListItem) {
                                        const numberElement = React.createElement(
                                            'span',
                                            Object.assign({ class: 'numbers numbers', style: { marginTop: '-4px' } } || {}, { key: 'number-' + key }),
                                            [(++listKey) + '.']
                                        )
                                        return React.createElement(
                                            'span',
                                            Object.assign(props || {}, { key }),
                                            [numberElement].concat(children)
                                        )
                                    }
                                    if (type === RichText.Elements.oList) {
                                        return React.createElement('span', Object.assign(props || {}, { key }), children)
                                    }
                                    if (type === RichText.Elements.hyperlink) {
                                        const targetAttr = element.data.target ? { target: element.data.target } : {};
                                        const relAttr = element.data.target ? { rel: 'noopener' } : {};
                                        props = Object.assign({
                                            style: { textDecoration: 'underline' },
                                            href: element.data.url || LinkResolver(element.data),
                                            target: element.data.url ? '_blank' : ''
                                        }, targetAttr, relAttr)
                                        return React.createElement('a', Object.assign(props || {}, { key }), children)
                                    }
                                    return null
                                }) +
                                `</div>`
                                : ``)
                            + (p.type === 'list-item' ?
                                `<div class="paragraph-normal-2">`
                                + RichText.asText([p], LinkResolver) +
                                `</div>`
                                : '')
                            + ((p.type === 'paragraph') ?
                                `<div class="paragraph-normal-2" >`
                                + RichText.asText([p], LinkResolver, (type, element, content, children, key) => {
                                    let props = {}
                                    if (type === RichText.Elements.hyperlink) {
                                        console.log("Slices?", slices);
                                        console.log("Current?", slices[sk]);
                                        console.log("Previous?", slices[sk - 1]);

                                        const targetAttr = element.data.target ? { target: element.data.target } : {};
                                        const relAttr = element.data.target ? { rel: 'noopener' } : {};
                                        props = Object.assign({
                                            style: { textDecoration: 'underline' },
                                            href: element.data.url || LinkResolver(element.data),
                                            target: element.data.url ? '_blank' : ''
                                        }, targetAttr, relAttr)
                                        return React.createElement('a', Object.assign(props || {}, { key }), children)
                                    }
                                    return null
                                }) +
                                `</div>`
                                : "")

                    })
                        + `[[DYNAMIC-ARTICLE-CONTENT]]`)

                    this.template[j] = this.template[j].replace("[[DYNAMIC-ARTICLE-CONTENT]]", `
                         </div>
                    </div>
                  [[DYNAMIC-ARTICLE-CONTENT]]`)
                }

                if (s.type === 'paragraph') {
                    var paragraph = (s.paragraph.map((p, k) => {
                        // console.log(p)
                        if (!p.text && p.spans.length === 0) {
                            return `<div style="display:none"></div>`
                        }
                        return `<div class="article-container w-clearfix">` +
                            ((p.type.indexOf('heading') !== -1) ?
                                `<h` + p.type.replace('heading', '') + ` class="article-secondary-headline margin-top-0px">`
                                + RichText.asText([p], LinkResolver) +
                                `</h` + p.type.replace('heading', '') + `>`
                                : '')
                            +
                            ((p.type === 'o-list-item') ?
                                `<div class="paragraph-normal-2 clearfix">` +
                                RichText.asText([p], LinkResolver, (type, element, content, children, key) => {
                                    let props = {}
                                    if (type === RichText.Elements.oListItem) {
                                        const numberElement = React.createElement(
                                            'span',
                                            Object.assign({ class: 'numbers numbers', style: { marginTop: '-4px' } } || {}, { key: 'number-' + key }),
                                            [(++listKey) + '.']
                                        )
                                        return React.createElement(
                                            'span',
                                            Object.assign(props || {}, { key }),
                                            [numberElement].concat(children)
                                        )
                                    }
                                    if (type === RichText.Elements.oList) {
                                        return React.createElement('span', Object.assign(props || {}, { key }), children)
                                    }
                                    if (type === RichText.Elements.hyperlink) {
                                        const targetAttr = element.data.target ? { target: element.data.target } : {};
                                        const relAttr = element.data.target ? { rel: 'noopener' } : {};
                                        props = Object.assign({
                                            style: { textDecoration: 'underline' },
                                            href: element.data.url || LinkResolver(element.data),
                                            target: element.data.url ? '_blank' : ''
                                        }, targetAttr, relAttr)
                                        return React.createElement('a', Object.assign(props || {}, { key }), children)
                                    }
                                    return null
                                }) +
                                `</div>`
                                : ``)
                            + (p.type === 'list-item' ?
                                `<div class="paragraph-normal-2">`
                                + RichText.asText([p], LinkResolver) +
                                `</div>`
                                : '')
                            + ((p.type === 'paragraph') ?
                                `<div class="paragraph-normal-2" >`
                                + ReactDOMServer.renderToString(RichText.render([p], LinkResolver, (type, element, content, children, key) => {
                                    let props = {}
                                    // console.log(type)
                                    if (type === RichText.Elements.hyperlink) {
                                        console.log("Slices?", slices);
                                        console.log("Current?", slices[sk]);
                                        console.log("Previous?", slices[sk - 1]);

                                        const targetAttr = element.data.target ? { target: element.data.target } : {};
                                        const relAttr = element.data.target ? { rel: 'noopener' } : {};
                                        props = Object.assign({
                                            style: { textDecoration: 'underline' },
                                            href: element.data.url || LinkResolver(element.data),
                                            target: element.data.url ? '_blank' : ''
                                        }, targetAttr, relAttr)
                                        return React.createElement('a', Object.assign(props || {}, { key }), children)
                                    }
                                    return null
                                })) +
                                `</div>`
                                : "")
                            + `</div>`
                    }))

                    this.template[j] = this.template[j].replace(`[[DYNAMIC-ARTICLE-CONTENT]]`, paragraph.join('&nbsp;') + `[[DYNAMIC-ARTICLE-CONTENT]]`)

                }

                if (s.type === 'quote') {
                    this.template[j] = this.template[j].replace("[[DYNAMIC-ARTICLE-CONTENT]]",
                        `<div class="quote-wrapper">
                     <amp-img alt="" src="https://startupguide.netlify.com/static/media/quotation-top.761b1d15.svg" height="30.5" width="23" class="top-quotation"></amp-img>
                     <blockquote class="p-blockquote">` + s.quote + `</blockquote>
                     <amp-img alt="" src="https://startupguide.netlify.com/static/media/quotation-bottom.6960ebdc.svg"  height="31.39" width="25" class="bottom-quotation"></amp-img>
                  </div>`
                        + `[[DYNAMIC-ARTICLE-CONTENT]]`)
                }

                if (s.type === 'highlighted_picture') {
                    this.getRealImgSize(s.highlightedPicture.picture)
                    this.template[j] = this.template[j].replace("[[DYNAMIC-ARTICLE-CONTENT]]", `
                        <div class="large-amp-img-container">
                           <amp-img  layout="intrinsic" alt="" src="` + s.highlightedPicture.picture + `" width="` + s.highlightedPicture.picture + `" height="` + s.highlightedPicture.picture + `"></amp-img>
                        </div>
                        <div class="image-caption">
                           <div class="caption-container">
                              <p class="image-caption">` + s.highlightedPicture.caption + `</p>
                           </div>
                        </div>`
                        + `[[DYNAMIC-ARTICLE-CONTENT]]`)
                }
                if (s.type === 'picture_duo') {
                    this.getRealImgSize(s.pictureDuo[0].picture)
                    this.getRealImgSize(s.pictureDuo[1].picture)

                    this.template[j] = this.template[j].replace("[[DYNAMIC-ARTICLE-CONTENT]]", `
                    <div class="article-container w-clearfix">
                        <div class="twoimages w-row">
                            <div class="column-43 w-col w-col-6 w-col-small-6">
                                <amp-img alt="" layout="intrinsic" alt="" width="` + s.pictureDuo[0].picture + `" height="` + s.pictureDuo[0].picture + `" src="` + s.pictureDuo[0].picture + `"></amp-img>
                            </div>
                            <div class="column-43 w-col w-col-6 w-col-small-6">
                                <amp-img alt="" layout="intrinsic" alt="" width="` + s.pictureDuo[1].picture + `" height="` + s.pictureDuo[1].picture + `" src="` + s.pictureDuo[1].picture + `"> </amp-img>
                            </div>
                        </div>
                    </div>
                    [[DYNAMIC-ARTICLE-CONTENT]]`)
                }

                if (s.type === 'embed') {
                    // console.log(s.embed);
                    if (s.embed.indexOf('facebook.com/') !== -1) {
                        this.template[j] = this.template[j].replace("[[DYNAMIC-ARTICLE-CONTENT]]", `
                      <amp-facebook  width="552" height="310"
                          layout="responsive"
                         `+ s.embed.match(/cite=".*?"/g)[0].replace('cite', "data-href") + `>
                      </amp-facebook>
                      [[DYNAMIC-ARTICLE-CONTENT]]`)

                    }
                    if (s.embed.indexOf('twitter.com/') !== -1) {
                        // console.log(s.embed.match(/twitter.com[\w/]+status\/[0-9]+/g)[0])
                        this.template[j] = this.template[j].replace("[[DYNAMIC-ARTICLE-CONTENT]]", `
                        <amp-twitter width="375"
                          height="472"
                          layout="responsive"
                          data-tweetid="`+ s.embed.match(/twitter.com[\w/]+status\/[0-9]+/g)[0].replace(/twitter.com[\w/]+status\//g, '') + `">
                        </amp-twitter>
                      [[DYNAMIC-ARTICLE-CONTENT]]`)

                    }
                }
            })

            this.template[j] = this.template[j].replace("[[DYNAMIC-ARTICLE-CONTENT]]", ``)
            this.template[j] = this.template[j].replace("[[DYNAMIC-ARTICLE-AUTHOR]]", `
          <div class="article-container w-clearfix">
             <div class="LazyLoad is-visible">
                <div class="article-footer">
                ` + (this.crawledArticles.articles[j].sponsor ? `
                   <div class="sponsor margin-bottom-24px" style="border-color: rgb(243, 164, 93);">
                      <div class="row-6 w-row">
                         <div class="column-45 w-col w-col-4 w-col-small-6 w-col-tiny-6">
                            <amp-img  height="30" alt="" src="`+ this.crawledArticles.articles[j].sponsor.logo + `"  class="sponsor-logo"></amp-img>
                         </div>
                         <div class="column-46 w-col w-col-8 w-col-small-6 w-col-tiny-6">
                            <p class="margin-bottom-8px">This post was created in partnership with ` + this.crawledArticles.articles[j].sponsor.name + `.<br />
                            ` + this.crawledArticles.articles[j].sponsor.description + `<br></p>
                         </div>
                      </div>
                   </div>
                   ` : '') + `
                   <div class="author-details">
                      <div class="row-7 w-row">
                         <div class="column-11 w-col w-col-4">
                            ` + (this.crawledArticles.articles[j].author.picture ? `<amp-img alt="" src="` + this.crawledArticles.articles[j].author.picture + `" width="173" height="173" class="image-50"></amp-img>` : ``) + `
                         </div>
                         <div class="column-12 w-col w-col-8">
                            <div class="author-data w-clearfix">
                               <h4 class="margin-bottom-8px">` + this.crawledArticles.articles[j].author.firstname + ` ` + this.crawledArticles.articles[j].author.lastname + `</h4>
                               <p class="margin-bottom-8px">`+ this.crawledArticles.articles[j].author.biography + `</p>
                               <ul class="article-author-social-icons margin-bottom-0px w-list-unstyled list-social-media">
                                    ` + ((this.crawledArticles.articles[j].author.facebook !== '') ? `
                                        <li class="icon">
                                            <a href="`+ this.crawledArticles.articles[j].author.facebook + `" target="_blank">
                                                <amp-img alt="" src="` + facebookIcon + `" width="24" height="24"></amp-img>
                                            </a>
                                        </li>
                                    `: ``)
                + ((this.crawledArticles.articles[j].author.twitter !== '') ? `
                                        <li class="icon">
                                            <a href="` + this.crawledArticles.articles[j].author.twitter + `" target="_blank">
                                                <amp-img alt="" src="` + twitterIcon + `" width="24" height="24"></amp-img>
                                            </a>
                                        </li>
                                    `: ``) +
                ((this.crawledArticles.articles[j].author.instagram !== '') ? `
                                        <li class="icon">
                                            <a href="` + this.crawledArticles.articles[j].author.instagram + `" target="_blank">
                                                <amp-img alt="" src="` + instagramIcon + `" width="24" height="24"></amp-img>
                                            </a>
                                        </li>
                                    `: ``)
                + ((this.crawledArticles.articles[j].author.website !== '') ? `
                                        <li class="icon">
                                            <a href="` + this.crawledArticles.articles[j].author.website + `" target="_blank">
                                                <amp-img alt="" src="` + websiteIcon + `" width="24" height="24"></amp-img>
                                            </a>
                                        </li>
                                    `: ``) +
                `
                               </ul>
                            </div>
                         </div>
                      </div>
                   </div>
                </div>
             </div>
          </div>
        `)

            this.template[j] = this.template[j].replace("[[DYNAMIC-RECOMENDATIONS]]", `
        <div class="recomended">[[DYNAMIC-RECOMENDATIONS]]`)

            if (this.crawledArticles.articles[j].group.latestArticles.length !== 0) {
                var imagesParsed = this.crawledArticles.articles[j].group.latestArticles.slice(0, 3).map((a, k) => {
                    return `<div class="column-35 w-col w-col-4">
                  <a style="all: unset;cursor: pointer;" class="link-block-9 w-inline-block" href="`+ a.link + `">
                  <amp-img width="345" height="202.06" alt="" style="border-bottom:solid 8px ` + this.crawledArticles.articles[j].group.color + `" src="` + a.picture + `" class="image-headline primary"></amp-img>
                  <div
                      class="div-block-16 busines"
                      style="background-color: '` + this.crawledArticles.articles[j].group.color + `'"
                  ></div>
                  <div>
                      <h3 class="heading-22 healdine">`+ a.title + `</h3>
                      <p class="paragraph-3">` + a.caption + `</p>
                  </div>
                  <div class="featured-info">
                      <div class="grey">` + a.author.firstname + ` ` + a.author.lastname + `</div>
                      <amp-img alt="" src="` + greyTimeIcon + `" width="13" height="13" class="featured-clock"></amp-img>
                      <div class="grey2">` + msToReadingTime(a.readingTime) + `</div>
                  </div>
                  </a>
              </div>`
                })
                this.template[j] = this.template[j].replace("[[DYNAMIC-RECOMENDATIONS]]", `
              <div class="category-related-articles">
                  <div class="more-on-txt" style="color: ` + this.crawledArticles.articles[j].group.color + `;">More on</div>
                  <div class="city-txt" style="color: ` + this.crawledArticles.articles[j].group.color + `; text-transform: 'uppercase'">
                      ` + this.crawledArticles.articles[j].group.name + `
                  </div>
              </div>
              <div class="row-business w-row">
              ` + imagesParsed.join('&nbsp;') + `
              </div>[[DYNAMIC-RECOMENDATIONS]]
            `)
            }
            if (this.crawledArticles.articles[j].group.articles.length > 3) {
                //     var morerecomendations = this.crawledArticles.articles[j].group.latestArticles.slice(3, 6).map((a, k) => {
                //         return `
                //
                //         <div class="column-35 w-col w-col-4">
                //             ` + (a.link ? `<a href={a.link} class="link-block-9 w-inline-block"><a/>`:``) + `
                //             <amp-img width="345" height="202.06" alt=""  src="` + a.picture + `" class="image-headline primary"></amp-img>
                //             <div>
                //                 <h3 class="heading-22 healdine">` + a.title + `</h3>
                //                 <p class="paragraph-3">` + a.caption + `</p>
                //             </div>
                //             <div class="featured-info">
                //                 <div class="grey">` + a.author.firstname + ` ` + a.author.lastname + `</div>
                //                 <amp-img alt="" src="` + greyTimeIcon + `" width="13" height="13" class="featured-clock"></amp-img>
                //                 <div class="grey2">` + msToReadingTime(a.readingTime) + `</div>
                //             </div>
                //         </div>`
                //       }
                //     )
                //     this.template[j] = this.template[j].replace("[[DYNAMIC-RECOMENDATIONS]]", `
                //     <div class="you-may-like w-hidden-small w-hidden-tiny">
                //         <div class="row-business w-row">
                //           ` + morerecomendations.join('&nbsp;') + `
                //         </div>
                //     </div>[[DYNAMIC-RECOMENDATIONS]]
                // `)
            }
            this.template[j] = this.template[j].replace("[[DYNAMIC-RECOMENDATIONS]]", `</div>`)
            this.template[j] = this.template[j].replace(`target=""`, `target="_blank"`)
            this.template[j] = this.template[j].replace(`<iframe`, `<amp-iframe`)
            this.template[j] = this.template[j].replace(`</iframe`, `</amp-iframe`)
            this.template[j] = this.template[j].replace(/href="\//g, `href="https://startupguide.com/`)

            this.pageButtons[this.pageButtons.length] = <button key={j} style={{ margin: `10px` }} onClick={() => this.download(this.crawledArticles.articles[j].slug, this.template[j])}>/{this.crawledArticles.articles[j].slug}</button>
            this.setState({ state: this.state });
        }
    }

    imageMap = []
    getRealImgSize(url) {
        var element = document.createElement('img');
        element.setAttribute('src', url);
        element.onload = () => {
            var realWidth = element.width;
            var realHeight = element.height;
            // alert("Original width=" + realWidth + ", " + "Original height=" + realHeight);
            this.imageMap.push({ 'url': url, "width": realWidth, "height": realHeight })
        };
    }
}

export default AmpBuilderPage
